// Customer type constants
export const CUSTOMER_TYPES = {
  PRIVATE: "private",
  CORPORATE: "corporate",
} as const;

export const CUSTOMER_TYPE_IDS = {
  PRIVATE: 1,
  CORPORATE: 2,
} as const;

export type CustomerType = (typeof CUSTOMER_TYPES)[keyof typeof CUSTOMER_TYPES];
